import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, LinearProgress } from '@mui/material'
import { useRichiestaServer, BaseFeedbackConIcona } from '@lucan/base-ui'
import { useAppContext } from 'GlobalContext'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import { useSessione } from 'context/SessioneProvider'
import { CHIAVE_VERBALE } from 'context/VerbaliProvider'
import useNavigate from 'utils/useNavigate'
import { useRestoreStepVerbale } from './Frontoffice/Verbale/useStepVerbale'
import Verbale from './Frontoffice/Verbale/Verbale'
import { SERVIZIO_FRONTOFFICE } from './Frontoffice/utilFrontoffice'

export default function ArrivoTechnicalDesign() {
  const { servizio, idPratica } = useParams()

  const { uri, idCliente } = useAppContext()

  const { salvaInSessione } = useSessione()

  const { navigate } = useNavigate()

  const [messaggio, setMessaggio] = useState(null)

  const {build} = useRestoreStepVerbale()

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServer()

  useEffect(() => {
    getTokenEPratica()

    async function getTokenEPratica() {
      if (!idCliente) return
      const { ok, data } = await getToken()
      if (ok) await getPratica(data.token)
      else setMessaggio('Impossibile recuperare una sessione attiva. Assicurarsi di aver effettuato l\'accesso all\'area personale del Comune.')
    }


    function getToken() {
      return new Promise(resolve => {
        const fd = new FormData()
        fd.append('idCliente', idCliente)
        fd.append('urlRed', window.location.href)

        // eslint-disable-next-line no-undef

        fetch(getBaseUrlTechnicalDesign(uri) + '/SP/isAut.ashx', {
          method: "POST",
          body: fd,
          credentials: "include" // equivalente a xhrFields.withCredentials
        })
        .then(res => res.json())
        .then(response => {
          if (response?.token) {
            resolve({ ok: true, data: { token: response.token } });
          } else {
            resolve({ ok: false });
          }
        })
        .catch(() => resolve({ ok: false }));
      })
    }

    async function getPratica(token) {
      const { ok, data } = await inviaOperazione(OPERAZIONI.PRATICHE_TOKEN, null, {}, {
        urlParams: { servizio },
        headers: { 'Authorization': token, uri },
        params: { idPratica }
      })
      if (ok) {
        const { esito, messaggio } = data
        if (esito) {
          if (servizio === SERVIZIO_FRONTOFFICE) {
            salvaInSessione(CHIAVE_VERBALE, idPratica)
            await build(idPratica)
            navigate(CHIAVI_ROUTES.FRONTOFFICE_VERBALE,{
              tab: Verbale.CHIAVI_TABS.DATI_VERBALE
            })
          } else {
            setMessaggio(`Servizio "${servizio}" non valido`)
          }
        } else {
          setMessaggio(messaggio.msg)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCliente, idPratica, servizio, uri])

  return (
    <Box sx={{ m: 2 }}>
      {inAttesaDelServer && <LinearProgress />}

      {ScatolaMessaggi}

      {messaggio && <BaseFeedbackConIcona.Errore messaggio={messaggio} />}
    </Box>
  )
}



function getBaseUrlTechnicalDesign(uri) {
  if (process.env.REACT_APP_ENV_NAME !== 'prod') {
    return 'https://www.pa-online.it/GisMasterWebSPreProd'
  }
  switch (uri) {
    case 'cuneo': return 'https://pratiche.comune.cuneo.it/GisMasterWebS'
    default: return 'https://www.pa-online.it/GisMasterWebS'
  }
}
